import {View} from "react-native";
import {useRouter} from "expo-router";
import ActionButton from "@/lib/components/ActionButton";
import {useGroup} from "@/lib/providers/GroupProvider";

export default function GroupHeader() {
    const router = useRouter();

    const {group} = useGroup();

    if (!group) {
        return null;
    }

    return (
        <View style={{flexDirection: "row", gap: 6}}>
            {group.permissions.invite && <ActionButton
                onPress={() => router.push(`/s/${group.group_id}/share`)}
                height={34}
                border={false}
                icon={"share"}
            />}
            {group.permissions.edit && <ActionButton
                onPress={() => router.push(`/s/${group.group_id}/edit`)}
                height={34}
                border={false}
                icon={"edit"}
            />}
        </View>
    )
}